import React, { Component } from 'react'
import styled from 'styled-components'
import {
    Modal,
    Form,
    Upload,
    Input,
    Button,
    Select,
    Switch,
    message
} from 'antd'
import { PlusOutlined, UploadOutlined, DeleteOutlined } from '@ant-design/icons'
import { uploadImage } from '../../../services/apiServices'
import {
    getRandomColor,
    getHomeRowBackground
} from '../../../services/appServices'
import RowLayout from './../../../commons/RowLayout/RowLayout'
import ColorSelector from '../../../commons/ColorSelector/ColorSelector'
import LoadingModal from '../../../commons/Modal/Loading'

const { Option } = Select

const PADDINGS = [0, 1, 2, 3, 4, 5]

const Container = styled.div`
    .image-wrapper,
    .colors-wrapper {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        > .item {
            margin-right: 10px;
            margin-bottom: 10px;
        }
    }
`

const BackgroundPreview = styled.div`
    margin-bottom: 34px;
    height: 120px;
    border-radius: 2px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
    background-size: cover;
    background-position: center center;
    ${props => getHomeRowBackground(props.colors, props.image)}
`

class RowEditor extends Component {
    state = {
        isLoading: false,
        fullscreen: false,
        colors: [],
        fileList: [],
        image: '',
        cssClass: '',
        paddingTop: 0,
        paddingBottom: 0
    }

    componentWillReceiveProps(nextProps) {
        if (!this.props.isOpen && nextProps.isOpen) {
            let row = nextProps.row
            this.setState({
                colors: row.background_colors
                    ? row.background_colors.split(',')
                    : [],
                fileList: [],
                image: row.background_image || '',
                cssClass: row.css_class || '',
                fullscreen: !!row.fullscreen,
                paddingTop: row.pt == 0 ? 0 : row.pt || 0,
                paddingBottom: row.pb == 0 ? 0 : row.pb || 0
            })
        }
    }

    async uploadImageBackground(file) {
        this.setState({ isLoading: true })
        try {
            let { image } = await uploadImage({ body: { file } })
            this.setState({ isLoading: false, image })
        } catch (error) {
            this.setState({ isLoading: false })
            message.error(this.props.T('SOMETHING_WRONG'))
        }
    }

    handleSubmit() {
        let data = {
            colors: this.state.colors ? this.state.colors.join(',') : '',
            image: this.state.image,
            cssClass: this.state.cssClass,
            fullscreen: this.state.fullscreen,
            paddingTop: this.state.paddingTop,
            paddingBottom: this.state.paddingBottom
        }
        this.props.onSubmit && this.props.onSubmit(data)
    }

    onAddColor() {
        let colors = [...this.state.colors]
        colors.push(getRandomColor())
        this.setState({ colors })
    }

    onChangeColor(index, color) {
        let colors = [...this.state.colors]
        colors[index] = color
        this.setState({ colors })
    }

    onRemoveColor(index) {
        let colors = [...this.state.colors]
        colors.splice(index, 1)
        this.setState({ colors })
    }

    onRemoveImage() {
        this.setState({
            image: ''
        })
    }

    onChangeBackgroundImage(e) {
        this.uploadImageBackground(e.file.originFileObj)
    }

    onChangeCssClass(cssClass) {
        this.setState({ cssClass })
    }

    onChangePadding(position, value) {
        if (position == 'TOP') {
            this.setState({ paddingTop: value })
        } else {
            this.setState({ paddingBottom: value })
        }
    }

    onChangeFullscreen(value) {
        this.setState({ fullscreen: value })
    }

    render() {
        let { T, isOpen, onClose } = this.props
        return (
            <Modal
                title={T('EDIT_ROW')}
                width={640}
                visible={isOpen}
                cancelText={T('CANCEL')}
                okText={T('SAVE')}
                onOk={this.handleSubmit.bind(this)}
                onCancel={() => onClose()}>
                <Container>
                    <Form labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                        <RowLayout title={T('FULL_WIDTH')} contentSpan={18}>
                            <Form.Item>
                                <Switch
                                    checked={this.state.fullscreen}
                                    onChange={this.onChangeFullscreen.bind(
                                        this
                                    )}
                                />
                            </Form.Item>
                        </RowLayout>
                        <RowLayout title={T('PADDING_TOP')} contentSpan={18}>
                            <Form.Item>
                                <Select
                                    value={this.state.paddingTop}
                                    style={{ width: 120 }}
                                    onChange={value =>
                                        this.onChangePadding('TOP', value)
                                    }>
                                    {PADDINGS.map(item => (
                                        <Option key={item} value={item}>
                                            {item}{' '}
                                            {item == 0 && ` (${T('DEFAULT')})`}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </RowLayout>
                        <RowLayout title={T('PADDING_BOTTOM')} contentSpan={18}>
                            <Form.Item>
                                <Select
                                    value={this.state.paddingBottom}
                                    style={{ width: 120 }}
                                    onChange={value =>
                                        this.onChangePadding('BOTTOM', value)
                                    }>
                                    {PADDINGS.map(item => (
                                        <Option key={item} value={item}>
                                            {item}{' '}
                                            {item == 0 && ` (${T('DEFAULT')})`}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </RowLayout>
                        <RowLayout
                            title={T('BACKGROUND_COLOR')}
                            contentSpan={18}
                            marginBottom={0}>
                            <Form.Item>
                                <div className="colors-wrapper">
                                    <div className="item">
                                        <Button
                                            onClick={() => this.onAddColor()}>
                                            <PlusOutlined /> {T('ADD_COLOR')}
                                        </Button>
                                    </div>
                                    {this.state.colors.map((color, index) => (
                                        <div key={index} className="item">
                                            <ColorSelector
                                                disableEditIcon
                                                color={color}
                                                onChange={color =>
                                                    this.onChangeColor(
                                                        index,
                                                        color
                                                    )
                                                }
                                                onRemove={() =>
                                                    this.onRemoveColor(index)
                                                }
                                            />
                                        </div>
                                    ))}
                                </div>
                            </Form.Item>
                        </RowLayout>
                        <RowLayout
                            title={T('BACKGROUND_IMAGE')}
                            contentSpan={14}
                            marginBottom={0}>
                            <Form.Item>
                                <div className="image-wrapper">
                                    <div className="item">
                                        <Upload
                                            accept="image/gif, image/jpeg, image/png, image/webp"
                                            fileList={this.state.fileList}
                                            customRequest={() => {}}
                                            onChange={e =>
                                                this.onChangeBackgroundImage(e)
                                            }>
                                            <Button
                                                type="primary"
                                                icon={<UploadOutlined />}>
                                                {T('UPLOAD')}
                                            </Button>
                                        </Upload>
                                    </div>
                                    {this.state.image && (
                                        <div className="item">
                                            <ImageUpload
                                                image={this.state.image}
                                                onRemove={() =>
                                                    this.onRemoveImage()
                                                }
                                            />
                                        </div>
                                    )}
                                </div>
                            </Form.Item>
                        </RowLayout>
                        {(this.state.colors.length > 0 || this.state.image) && (
                            <RowLayout
                                title={T('EXAMPLE_BACKGROUND')}
                                contentSpan={18}>
                                <BackgroundPreview
                                    colors={this.state.colors.join(',')}
                                    image={this.state.image}
                                />
                            </RowLayout>
                        )}

                        <RowLayout
                            title={T('ADDITIONAL_CSS_CLASSES')}
                            contentSpan={14}>
                            <Input
                                placeholder="e.g. class1 class2 class3 ..."
                                value={this.state.cssClass}
                                onChange={e =>
                                    this.onChangeCssClass(e.target.value)
                                }
                            />
                        </RowLayout>
                    </Form>

                    <LoadingModal isOpen={this.state.isLoading} />
                </Container>
            </Modal>
        )
    }
}

const ImageUploadThumbnai = styled.div`
    width: 40px;
    height: 30px;
    background-size: cover;
    background-position: center center;
    background-image: url(${props => props.image});
`

const ImageUpload = ({ image, onRemove }) => (
    <Button.Group style={{ display: 'flex' }}>
        <Button style={{ padding: 0, overflow: 'hidden' }}>
            <ImageUploadThumbnai image={image} />
        </Button>

        <Button onClick={() => onRemove()}>
            <DeleteOutlined />
        </Button>
    </Button.Group>
)

export default RowEditor
